const LangBar = () => {

    const showBar = localStorage.getItem('showBar');
    var LangBarHTML = $('.region-bar');
    var body = document.body;

    if(showBar === 'false'){
        $(LangBarHTML).hide();
        body.classList.add('lang-bar-hidden');
    }

    var closeTrigger = $('.region-bar__menu-mobile-toggle');
    closeTrigger.on('click', function() {
        $(LangBarHTML).hide();
        body.classList.add('lang-bar-hidden');
        localStorage.setItem('showBar', 'false');
    });

}

export default LangBar;


// WEBPACK FOOTER //
// ./src/js/app/components/LangBar.js